import { render, staticRenderFns } from "./PurchaseItems.vue?vue&type=template&id=0acbe28c&scoped=true"
import script from "./PurchaseItems.vue?vue&type=script&lang=js"
export * from "./PurchaseItems.vue?vue&type=script&lang=js"
import style0 from "./PurchaseItems.vue?vue&type=style&index=0&id=0acbe28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbe28c",
  null
  
)

export default component.exports